<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        <span class="accent--text pe-1">
          {{ value ? value.material_name : "" }}
        </span>
        {{ $t("MaterialTemplate.shopLastPrice", [$consts.shopName()]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="last_prices"
        :loading="loading"
        multi-sort
        disable-pagination
        hide-default-footer
        class="elevation-0 px-6"
        height="400px"
        fixed-header
      >
        <template v-slot:item.price="{ item }">
          {{ $t("Global.money") }}{{ item.price | formatMoney }}
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import LastPrices from "@/api/last_prices";

export default {
  name: "LastPrice",

  props: {
    value: Object,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: true,
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: true,
          value: "shop_name",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.supply_price"),
          align: "end",
          sortable: true,
          value: "price",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.unit"),
          align: "center",
          sortable: true,
          value: "unit",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    last_prices: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value && this.value.material_id) {
          this.dialog = true;
          LastPrices.fetch({ material_id: this.value.material_id }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.last_prices = response.data.last_prices;
              }
            }.bind(this)
          );
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.$emit("input", null);
        }
      },
    },
  },
};
</script>